// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1eb4V","modalFooterButton":"ModalNotes_modalFooterButton__19wtW"};